export default () => ({
  trigger: {
    name: 'promo_icons.show_promo_icon',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
